// extracted by mini-css-extract-plugin
export default {"container":"Success_container__8PnaZ","royalList":"Success_royalList__92uo6","last":"Success_last__+66UO","check":"Success_check__KTbdb","disclaimer":"Success_disclaimer__iFmMe"};